module.exports = __webpack_public_path__ + "img/r-cb6-y1.0bdbd3e7.gif";